import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import config from "../Config";
import "./animations.css";

gsap.registerPlugin(ScrollTrigger);

const Animation4: React.FC = () => {
  const racesRef = useRef<HTMLDivElement | null>(null);
  const racesWrapperRef = useRef<HTMLDivElement | null>(null);

  const slides = [
    { year: "2014", text: "TCB Pay was founded in <b>Henderson, NV.</b>", img: "abut-line.png", color: "bluebx" },
    { year: "2015", text: "Opened a satellite office in <b>Los Angeles, CA.</b>", img: "abut-line1.png", color: "yelwbx" },
    { year: "2017", text: "Began hiring an in-house development team to <b>build proprietary software/tools.</b>", img: "abut-line2.png", color: "bluebx" },
    { year: "2018", text: "Opened a satellite office in Toronto, Canada.", img: "abut-line3.png", color: "yelwbx" },
    { year: "2019", text: "The first <b>TCB Pay Gateway</b> was created.", img: "abut-line4.png", color: "bluebx" },
    { year: "2020", text: "The <b>TCB Pay Web Application</b> and the <b>TCB Pay App</b> were released.", img: "abut-line5.png", color: "yelwbx" },
    { year: "2021", text: "Achieved <b>PCI Level 1 Compliance</b> status certified by WorldPay.", img: "abut-line6.png", color: "bluebx" },
    { year: "2022", text: "Became certified with <b>TSYS.</b> Moved headquarters to <b>Boca Raton, FL.</b>", img: "abut-line7.png", color: "yelwbx" },
    { year: "2023", text: "<b>TCB Pay Issuing</b> was released. <span> Opened a satellite office in <b>Malta</b> and <b>New York City.</b></span>", img: "abut-line8.png", color: "bluebx" },
    { year: "2024", text: "Launch of the <b>TCB Pay Portal,</b> an upgraded version of the TCB Pay Gateway featuring significant enhancements and additional functionalities.", img: "abut-line9.png", color: "yelwbx" },
    { year: "2025", text: "<b>TCB Pay Portal App</b> launch. <span>Made the entire TCB Pay platform multilingual, now supporting <b>French</b> and <b>Spanish.</b></span>", img: "nwabut-line11.png", color: "bluebx" },
  ];

  useEffect(() => {
    const races = racesRef.current;
    const wrapper = racesWrapperRef.current;
    if (!races || !wrapper) return;

    let tween: GSAPAnimation;
    const scrollSpeed = 1;

    const calculateSlidesPerView = () => {
      const width = window.innerWidth;
      if (width < 576) return 1;
      if (width < 768) return 2;
      if (width < 1200) return 4;
      if (width < 1400) return 4;
      if (width < 1900) return 5;
      if (width < 2400) return 5;
      return 4;
    };

    const buildAnimation = () => {
      const slidesPerView = calculateSlidesPerView();
      const gap = 0; // space between slides in px
      const slideWidth = (window.innerWidth - gap * (slidesPerView - 1)) / slidesPerView;

      gsap.set(".scroll-item", { width: slideWidth, marginRight: `${gap}px`, flexShrink: 0 });

      if (tween) tween.kill();

      tween = gsap.to(races, {
        x: () => {
          const totalWidth = races.scrollWidth;
          const moveX = totalWidth - window.innerWidth;
          return moveX > 0 ? -moveX : 0;
        },
        ease: "none",
      });

      // Fade in/out animation for slides
      gsap.utils.toArray<HTMLElement>(".scroll-item").forEach((slide) => {
        gsap.fromTo(
          slide,
          { autoAlpha: 0, scale: 1 },
          {
            autoAlpha: 1,
            scale: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: slide,
              containerAnimation: tween,
              //start: "left center",
              end: "right center",
              scrub: 0.3,
            },
          }
        );
      });

      // ScrollTrigger for horizontal scroll
      ScrollTrigger.create({
        trigger: wrapper,
        start: "top top",
        end: () => `+=${races.scrollWidth - window.innerWidth}`,
        pin: true,
        scrub: 0.3,
        animation: tween,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      });
    };

    buildAnimation();

    window.addEventListener("resize", () => {
      ScrollTrigger.getAll().forEach((st) => st.kill());
      buildAnimation();
      ScrollTrigger.refresh();
    });

    // Smooth wheel scroll
    // let isScrolling = false;
    // const onWheel = (e: WheelEvent) => {
    //   e.preventDefault();
    //   if (isScrolling) return;
    //   isScrolling = true;
    //   const delta = e.deltaY * 1.2;
    //   window.scrollTo({ top: window.scrollY + delta, behavior: "smooth" });
    //   setTimeout(() => (isScrolling = false), 50);
    // };
    // window.addEventListener("wheel", onWheel, { passive: false });

    return () => {
      //window.removeEventListener("wheel", onWheel);
      ScrollTrigger.getAll().forEach((st) => st.kill());
      if (tween) tween.kill();
    };
  }, []);

  return (
    <div
      className="racesWrapper"
      ref={racesWrapperRef}
      style={{ overflow: "hidden", width: "100%", position: "relative", margin:"20px" }}
    ><h6 className="seamless-heading mb-90">Our story</h6>
      <div
        className="races"
        ref={racesRef}
        style={{
          display: "flex",
          gap: "0px",
          width: "max-content",
          padding: "0 0",
          alignItems: "center",
        }}
      >
        {slides.map((item, i) => (
          <div className="scroll-item" key={i}>
            <div className="slider-swiperbx1">
              <div className="abut-linecruve">
                <img
                  src={`${config.siteBaseUrl}/assets/imgs/about/${item.img}`}
                  alt=""
                />
              </div>
              <div className={item.color}>
                <h4>{item.year}</h4>
                <p dangerouslySetInnerHTML={{ __html: item.text }}></p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation4;
